/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationBackfillResultDto } from '../models/NotificationBackfillResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class NotificationBackfillService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Preview what the backfill would do for an org without writing anything.
     * @param orgGuid
     * @returns NotificationBackfillResultDto OK
     * @throws ApiError
     */
    public getApiNotificationBackfillPreview(
        orgGuid: string,
    ): CancelablePromise<NotificationBackfillResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/NotificationBackfill/{orgGuid}/Preview',
            path: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Run the backfill for an org. Defaults to a dry run; pass dryRun=false to write.
     *
     * When clearExisting is true (and not a dry run), ALL scheduler queue items
     * and delivered reminders for the org are deleted first, then the backfill regenerates them from
     * current source data. This is the "reset" path for the anonymization flow — destructive and
     * org-wide. On a dry run the would-clear counts are reported but nothing is deleted.
     * @param orgGuid
     * @param dryRun
     * @param clearExisting
     * @returns NotificationBackfillResultDto OK
     * @throws ApiError
     */
    public postApiNotificationBackfillRun(
        orgGuid: string,
        dryRun: boolean = true,
        clearExisting: boolean = false,
    ): CancelablePromise<NotificationBackfillResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/NotificationBackfill/{orgGuid}/Run',
            path: {
                'orgGuid': orgGuid,
            },
            query: {
                'dryRun': dryRun,
                'clearExisting': clearExisting,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
